import React from "react";
import { View, StyleSheet, TouchableWithoutFeedback, TouchableOpacity } from "react-native";
import { Image } from "react-native-expo-image-cache";

import Text from "./Text";
import colors from "../config/colors";
import { MaterialCommunityIcons } from "@expo/vector-icons";

function Card({ title, 
                subTitle, 
                imageUrl, 
                onPress, 
                onPressLike,
                onPressComment, 
                onPressNumLikes, 
                thumbnailUrl,
                commentsNum
                }) {
  return (

      <View style={styles.card}>
        <TouchableOpacity onPress={onPress}>
          <Image
            onPress={onPress}
            style={styles.image}
            tint="light"
            preview={{ uri: thumbnailUrl }}
            uri={imageUrl}
            resizeMode="center"              
          />
        </TouchableOpacity>
        <View style={styles.detailsContainer}>
          <Text style={styles.title} numberOfLines={1}>
            {title}
          </Text>
          <View style={styles.likeAndCommentContainer}>
            <Text style={styles.subTitle} numberOfLines={2} onPress={onPressNumLikes}>
            {subTitle}
            </Text>
            <Text style={styles.commentsNum} numberOfLines={1} >
              {commentsNum}
            </Text>
          </View>
          <View style={styles.likeAndCommentContainer}>
            <MaterialCommunityIcons name={"brain"} color={"red"} size={35} onPress={onPressLike}  >
            </MaterialCommunityIcons>
            <Text style={styles.likes} numberOfLines={1} >
              <MaterialCommunityIcons name={"comment-text-outline"} color={"grey"} size={20} onPress={onPressComment}  >
                comment
              </MaterialCommunityIcons>    
            </Text>
          </View>
        </View>
      </View>

  );
}

const styles = StyleSheet.create({
  card: {
    borderRadius: 15,
    backgroundColor: colors.white,
    marginBottom: 20,
    overflow: "hidden",
  },
  detailsContainer: {
    padding: 20,
  },
  image: {
    width: "100%",
    height: 200,
  },
  likeAndCommentContainer: {
     flexDirection: "row",
     width: "100%",
     height: 30,
  },
  likes: {
    marginLeft: "50%",
 },
 commentsNum:{
  marginLeft: "70%",
 },
  subTitle: {
    color: colors.dark,
    fontWeight: "bold",
  },
  title: {
    marginBottom: 7,
  },
});

export default Card;
